// @types/react 17 `useId` bildirmiyor; çalışma anındaki React 18.3'te var. Türler yükselince yönerge hata verir, kaldırılır.
// @ts-expect-error TS2305
import { ReactNode, useId } from 'react'
import { IDrillSelection } from '../models'
import { formatCount, formatPercent, NO_RATE_TEXT } from '../viewModel'
import styles from './ChatbotManagementReport.module.scss'

/** Table hücre biçimleyicileri: ham sayı sıralanır, biçimli metin görünür. */
export const countCell = ({ value }: { value: number }) => formatCount(value)
export const percentCell = ({ value }: { value: number }) => formatPercent(value)

/**
 * ORAN hücresi (başarı / veri yok / fallback %): satırın paydası 0 ise (`noRate`) sunucunun yolladığı 0 yerine "—"
 * basar (spec §4.3). PAY (%) bir oran değildir; paylar percentCell'de kalır.
 */
export const evaluatedRateCell = ({ value, row }: { value: number; row: { original: { noRate?: boolean } } }) =>
  row.original.noRate ? NO_RATE_TEXT : formatPercent(value)

export type DrillHandler = (selection: IDrillSelection) => void

/**
 * Detaya inen hücre (spec §8.6): onDrill verilmişse ve satır bir seçime karşılık geliyorsa değeri bağlantı
 * görünümlü bir düğme olarak basar; aksi hâlde düz metin.
 */
export const makeDrillCell =
  (
    onDrill: DrillHandler | undefined,
    toSelection: (row: any) => IDrillSelection | null,
    render: (value: any) => ReactNode = value => value
  ) =>
  ({ value, row }: { value: any; row: { original: any } }) => {
    const selection = onDrill ? toSelection(row.original) : null
    if (!selection || !onDrill) return render(value)
    return (
      <button type='button' className={styles.drillLink} onClick={() => onDrill(selection)}>
        {render(value)}
      </button>
    )
  }

export function ReportSection({ number, title, children }: { number?: number; title: string; children: ReactNode }) {
  const headingId = useId()
  return (
    <section className={styles.section} aria-labelledby={headingId}>
      <header className={styles.sectionHeader}>
        {number ? (
          <span className={styles.sectionNumber} aria-hidden='true'>
            {number}
          </span>
        ) : null}
        <h2 id={headingId}>{title}</h2>
      </header>
      {children}
    </section>
  )
}

export function TotalLine({ children }: { children: ReactNode }) {
  return <p className={styles.totalLine}>{children}</p>
}
